<template>
  <div>
    <div class="map-general">
      <l-map
        ref="myMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        @click="clickMark"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          :draggable="true"
          :lat-lng.sync="item.position"
          :icon="myIcon"
          v-for="item in marks"
          :key="item.lng"
        />
      </l-map>
    </div>
    <v-btn @click="search()" :loading="loading" small color="primary">{{
      $t('action.buttons.search')
    }}</v-btn>
    {{ location || $t('titles.global.nonAddress') }}
    <div v-if="marks.length > 0">
      <v-btn small color="success" @click="confirmLocation()">{{
        $t('action.buttons.confirm')
      }}</v-btn>
    </div>
    <table style="width: 100%" v-if="marks.length > 0">
      <caption>
        {{
          $t('titles.global.selected')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('titles.global.coordinates') }}</th>
          <th>{{ $t('fields.users.address') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in marks" :key="item.lat">
          <td>{{ item.position.lat }}, {{ item.position.lng }}</td>
          <td>{{ item.name }}</td>
        </tr>
      </tbody>
    </table>
    <table style="width: 100%" v-if="searchResult.length > 0">
      <caption>
        {{
          $t('titles.global.available')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('titles.global.selected') }}</th>
          <th>{{ $t('titles.global.coordinates') }}</th>
          <th>{{ $t('titles.global.foundAddress') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="selectable"
          v-for="(item, index) in searchResult"
          :key="item.lat"
          @click="selectAddress(index)"
        >
          <td>
            <button-state :state="item.select" />
          </td>
          <td>{{ item.position.lat }}, {{ item.position.lng }}</td>
          <td>{{ item.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { latLng } from 'leaflet'
import { LMap, LMarker, LPopup, LTileLayer, LTooltip } from 'vue2-leaflet'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import LGeosearch from 'vue2-leaflet-geosearch'

export default {
  name: 'GeoMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LGeosearch,
  },
  props: {
    location: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      required: false,
      default: 'create',
      validator: function (value) {
        return ['create', 'update', 'delete', 'view'].indexOf(value) !== -1
      },
    },
    limitMark: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data() {
    return {
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
      },
      zoom: 13,
      center: latLng(41.390205, 2.154007),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 8.5,
      currentCenter: latLng(41.390205, 2.154007),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      marks: [],
      searchResult: [],
      myIcon: L.icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        iconSize: [25, 41],
        iconAnchor: [16, 37],
        shadowUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png',
        shadowSize: [41, 41],
        shadowAnchor: [16, 37],
      }),
      listLocation: 0,

      loading: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.myMap.mapObject.invalidateSize()
    })
    let me = this
    setTimeout(function () {
      me.$refs.myMap.mapObject.invalidateSize()
    }, 1000)
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    showLongText() {
      this.showParagraph = !this.showParagraph
    },
    innerClick() {
      // alert('Click!')
    },
    async search() {
      if (!this.location) return
      this.loading = true
      let result = await this.geosearchOptions.provider.search({
        query: this.location,
      })
      this.loading = false
      this.searchResult = []
      result.forEach((item) =>
        this.searchResult.push({
          position: {
            lat: item.y,
            lng: item.x,
          },
          name: item.label,
          select: false,
        })
      )
      this.listLocation = 0
      if (this.searchResult.length === 1) {
        this.marks = this.searchResult
        this.searchResult[0].select = true
        this.$nextTick((_) => {
          this.center = latLng(
            this.marks[0].position.lat,
            this.marks[0].position.lng
          )
          this.zoom = 13
        })
      } else {
        this.marks = []
      }
    },
    selectAddress(index) {
      this.searchResult.forEach((item) => (item.select = false))
      this.searchResult[index].select = true
      this.marks = []
      this.marks.push(this.searchResult[index])
      if (this.marks.length > 0) {
        this.center = latLng(
          this.marks[0].position.lat,
          this.marks[0].position.lng
        )
        this.zoom = 13
      } else {
        this.center = latLng(41.390205, 2.154007)
        this.zoom = 7
      }
    },
    clickMark(item) {
      this.marks = []
      this.marks.push({
        name: this.location,
        position: item.latlng,
      })
      this.center = latLng(
        this.marks[0].position.lat,
        this.marks[0].position.lng
      )
      this.searchResult.forEach((item) => (item.select = false))
    },
    confirmLocation() {
      if (this.marks.length === 0) {
        return
      }
      this.$emit('location', this.marks[0].position)
    },
    autoCenter() {
      // this.center = latLng(41.390205, 2.154007)
      // this.zoom = 7
    },
  },
}
</script>
<style lang="scss">
.map-general {
  height: 100%;
  max-height: 400px;
  min-height: 400px;
  max-width: 400px;
  margin: 0;
}

.selectable {
  &:hover {
    cursor: pointer;
    background: #e0e0e0;
  }
}
</style>
